export default __webpack_public_path__ + "static/media/card-view.4c8c6cf7.svg";